import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const NoStyleLink = styled(Link)`
  color: inherit;
  text-transform: inherit;
  text-decoration: inherit;
  font-weight: inherit;
  font-size: inherit;
  transition: opacity 250ms ease-out;

  &:hover {
    opacity: 0.7;
  }
`;



// WEBPACK FOOTER //
// ./src/styles/NoStyleLink.js